import styled, { css } from 'styled-components'

export const View = styled.strong`
  ${({ color }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 100px;
    height: 20px;
    border-radius: 10px;
    color: #fff;
    padding: 8px 8px;
    background: ${color};
    white-space: nowrap;
  `}
`
